import { Heading, Icon, Input, Modal, ModalBody, Button, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { MdAddBusiness } from "react-icons/md";
import { useSelector } from "react-redux";
import { POST } from "../../utils/ApiRequestProvider";
import { RefreshBusinesses } from "../../utils/ReduxUtils";
import APIDropdown from "../Select/APIDropdown";

export interface BusinessModalForm {
    businessName: string;
    businessShortName: string;
    documentInbox: string;
    businessType: string;
    organizationType: string;
    contactNumber: string;
    countryId: number;
    currencyId: number;
    stateId: number;
    isOrganization: boolean;
}
export default function BusinessModal() {
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const businesses = useSelector((state: any) => state.businesses.value);

    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState<Array<any>>([]);
    const [form, setForm] = useState<BusinessModalForm>({
        businessName: '',
        businessShortName: '',
        documentInbox: '',
        businessType: '',
        organizationType: '',
        contactNumber: '',
        countryId: 0,
        currencyId: 0,
        stateId: 0,
        isOrganization: true,
    });

    useEffect(() => {
        if (businesses) {
            if (businesses.length === 0) {
                onOpen();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [businesses]);

    async function Save() {
        try {
            setLoading(true);
            const response = await POST('/api/business/create', form);
            toast({
                status: response.status,
                title: response.message,
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            setLoading(false);
            if (response.status === 'success') {
                onClose();
                RefreshBusinesses();
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }

    }
    return (
        <Modal
            isCentered
            size={'3xl'}
            isOpen={isOpen}
            onClose={onClose}
            closeOnOverlayClick={false}
        >
            <ModalOverlay
                bg='blackAlpha.300'
                backdropFilter='blur(10px)'
            />
            <ModalContent>
                <ModalHeader
                    as={Stack}
                    direction={'row'}
                    borderBottom={'2px'}
                    borderBottomColor={'gray.300'}
                >
                    <Icon
                        as={MdAddBusiness}
                        fontSize={'5xl'}
                        color={'primary.400'}
                    />
                    <Stack spacing={0}>
                        <Heading fontSize={'xl'}>Add New Business</Heading>
                        <Text fontSize={'sm'}>Create new Business Profile</Text>
                    </Stack>
                </ModalHeader>
                <ModalBody as={Stack} direction={'row'} spacing={4} py={8}>
                    <Stack spacing={4} w={'full'}>
                        <Input
                            w={'full'}
                            type={'text'}
                            size={'md'}
                            placeholder={'Business / Person Name'}
                            value={form.businessName}
                            onChange={(e: any) => setForm({ ...form, businessName: e.target.value })}
                        />
                        <Input
                            w={'full'}
                            type={'text'}
                            size={'md'}
                            placeholder={'Business / Short Name'}
                            value={form.businessShortName}
                            onChange={(e: any) => {
                                setForm({
                                    ...form,
                                    businessShortName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                                    documentInbox: e.target.value.replace(/[^a-zA-Z ]/g, '').replace(/ /g, "-").toLowerCase() + `@app.entry-bot.com`
                                })
                            }}
                        />
                        <Select
                            w={'full'}
                            placeholder='Business Type'
                            value={form.businessType}
                            onChange={(e: any) =>
                                setForm({ ...form, businessType: e.target.value })
                            }
                        >
                            <option value={'Accountant/Bookkeeper/TaxAdvisor'}>Accountant/Bookkeeper/TaxAdvisor</option>
                            <option value={'Beauty Salons and Spas'}>Beauty Salons and Spas</option>
                            <option value={'Building and Construction'}>Building and Construction</option>
                            <option value={'Business Consulting'}>Business Consulting</option>
                            <option value={'Cleaning Services'}>Cleaning Services</option>
                            <option value={'E-Commerce'}>E-Commerce</option>
                            <option value={'Engineering Firms and Contractors'}>Engineering Firms and Contractors</option>
                            <option value={'Fashion Industry'}>Fashion Industry</option>
                            <option value={'Food and Beverages'}>Food and Beverages</option>
                            <option value={'Hospitality and Tourism'}>Hospitality and Tourism</option>
                            <option value={'IT and Web Services'}>IT and Web Services</option>
                            <option value={'Law Firm'}>Law Firm</option>
                            <option value={'Leisure and Fitness'}>Leisure and Fitness</option>
                            <option value={'Marketing and Social Media Marketing'}>Marketing and Social Media Marketing</option>
                            <option value={'Other'}>Other</option>
                            <option value={'Petrol Retailers'}>Petrol Retailers</option>
                            <option value={'Recruitment Firms'}>Recruitment Firms</option>
                            <option value={'Restaurants and Cafes'}>Restaurants and Cafes</option>
                            <option value={'Travel Industry'}>Travel Industry</option>
                            <option value={'Warehousing and Logistics'}>Warehousing and Logistics</option>
                        </Select>
                        <APIDropdown
                            w={'full'}
                            placeholder={'Country Name'}
                            fetchurl={'/api/country'}
                            itemselect={(item) => {
                                setForm({ ...form, countryId: item.id })
                                setStates(item.states);
                            }}
                            valuekey={'id'}
                            textkey={'name'}
                        />
                        <Select
                            w={'full'}
                            placeholder='City / State'
                            value={form.stateId}
                            onChange={(e: any) =>
                                setForm({ ...form, stateId: parseInt(e.target.value) })
                            }
                        >
                            {
                                states.map(s => (
                                    <option value={s.id}>{s.name}</option>
                                ))
                            }
                        </Select>
                    </Stack>
                    <Stack spacing={4} w={'full'}>
                        <Select
                            w={'full'}
                            placeholder='Organization Type'
                            value={form.organizationType}
                            onChange={(e: any) =>
                                setForm({ ...form, organizationType: e.target.value })
                            }
                        >
                            <option value={'Limited Company'}>Limited Company</option>
                            <option value={'Not for Profit'}>Not for Profit</option>
                            <option value={'Partnership'}>Partnership</option>
                            <option value={'Person'}>Person</option>
                            <option value={'Sole Traders'}>Sole Traders</option>
                            <option value={'Other'}>Other</option>
                        </Select>
                        <Input
                            w={'full'}
                            type={'text'}
                            size={'md'}
                            value={form.documentInbox}
                            disabled
                            placeholder={'Document Inbox'}
                        />
                        <Input
                            w={'full'}
                            type={'text'}
                            size={'md'}
                            value={form.contactNumber}
                            onChange={(e: any) => setForm({ ...form, contactNumber: e.target.value })}
                            placeholder={'Contact Number'} />
                        <APIDropdown
                            w={'full'}
                            placeholder={'Base Currency'}
                            fetchurl={'/api/currency'}
                            itemselect={(item) => setForm({ ...form, currencyId: item.id })}
                            valuekey={'id'}
                            textkey={'currencyName'}
                        />
                    </Stack>
                </ModalBody>
                <ModalFooter
                    as={Stack}
                    direction={'row'}
                    spacing={4}
                    borderTop={'2px'}
                    borderTopColor={'gray.300'}
                >
                    <Button
                        w={'full'}
                        onClick={Save}
                        leftIcon={<FaCheck />}
                        colorScheme={'primary'}
                        isLoading={loading}
                    >
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}